import axios from '../http.js'

//课程资源分页
function getCourseResourceList(data) {
    return axios.baseAxios({
      url: '/backstage/courseResource/queryPage',
      method: 'post',
      data: data
    })
}

//保存资源
function saveResource(data) {
  return axios.baseAxios({
    url: '/backstage/courseResource/saveResource',
    method: 'post',
    data: data
  })
}

//保存资源
function deleteResource(resourceId) {
  return axios.baseAxios({
    url: '/backstage/courseResource/deleteResource?resourceId=' + resourceId,
    method: 'get'
  })
}

function getResourceDetail(resourceId) {
  return axios.baseAxios({
    url: '/backstage/courseResource/getResourceDetail?resourceId=' + resourceId,
    method: 'get'
  })
}

//发布/撤销发布
function publishOrUnPublish(resourceId) {
  return axios.baseAxios({
    url: '/backstage/courseResource/publishOrUnPublish?resourceId=' + resourceId,
    method: 'get'
  })
}
//获取树状列表
function getTreeList(resourceId) {
  return axios.baseAxios({
    url: '/backstage/courseResourceGroup/getNormalTreeList?courseResourceId=' + resourceId,
    method: 'get'
  })
}
//保存资源分组
function saveResourceGroup(data) {
  return axios.baseAxios({
    url: '/backstage/courseResourceGroup/saveResource',
    method: 'post',
    data:data
  })
}
//删除资源分组
function deleteResourceGroup(id) {
  return axios.baseAxios({
    url: '/backstage/courseResourceGroup/delete?id=' + id,
    method: 'get'
  })
}
//
function uploadFile(data) {
  return axios.formDataAxios({
    url: '/backstage/courseResourceGroup/uploadFile',
    method: 'post',
    data:data
  })
}

export default {
  getCourseResourceList,
  saveResource,
  deleteResource,
  getResourceDetail,
  publishOrUnPublish,
  getTreeList,
  saveResourceGroup,
  deleteResourceGroup,
  uploadFile
}


// WEBPACK FOOTER //
// ./src/api/modules/resourceManage.js